import { useReadPresetApi } from '@aibees/shared/api';
import useTransferListStore from '../store/transfer-list-store';
import { TransferListPresetValue } from '../types';

export function useCompareTransferListChanges(id?: string) {
  const store = useTransferListStore();
  const { data } = useReadPresetApi<TransferListPresetValue>(id!, {
    enabled: !!id,
  });

  if (!data) return true;

  const arraysEqual = (arr1: string[] = [], arr2: string[] = []) => {
    if (arr1.length !== arr2.length) return false;
    const sorted1 = [...arr1].sort();
    const sorted2 = [...arr2].sort();
    return sorted1.every((val, index) => val === sorted2[index]);
  };

  const includedChanged = !arraysEqual(store.included, data.value.included);
  const excludedChanged = !arraysEqual(store.excluded, data.value.excluded);

  return includedChanged || excludedChanged;
}
